module.exports = __webpack_public_path__ + "assets/img/Integrity_badge_Light_DK.b752429f.png";